// src/pages/VerifyEmailPage.jsx

import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../api/api'; // Tu instancia de axios

export default function VerifyEmailPage() {
    // Hook para leer los parámetros de la URL (e.g., ?token=...)
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading'); // 'loading', 'prompt', 'success', 'error'
    const [message, setMessage] = useState('Cargando...');

    // 1. Capturar el token de la URL
    const token = searchParams.get('token');

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage('Token de verificación no encontrado en la URL.');
        } else {
            // Si el token existe, le pedimos al usuario que haga clic en el botón
            setStatus('prompt');
            setMessage('Haz clic a continuación para finalizar la verificación de tu cuenta.');
        }
    }, [token]);

    // 2. Función para enviar el token al Backend
    const handleVerification = async () => {
        setStatus('loading');
        setMessage('Verificando tu cuenta, por favor espera...');
        
        try {
            // Petición POST al backend enviando el token
            const res = await api.post('/auth/verify', { token });
            
            setStatus('success');
            setMessage(res.data.message || '¡Felicidades! Tu cuenta ha sido verificada con éxito. Ya puedes iniciar sesión.');
            
        } catch (error) {
            setStatus('error');
            setMessage(error.response?.data?.message || 'Error de verificación. El enlace puede ser inválido o haber expirado.');
        }
    };

    const getStatusIcon = () => {
        if (status === 'success') return '✅';
        if (status === 'error') return '❌';
        if (status === 'loading') return '⏳';
        return '❓';
    };

    return (
        <div 
            style={{ 
                height: '100vh', 
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'center', 
                alignItems: 'center', 
                background: '#FAFAFA' 
            }}
        >
            <div style={{ 
                textAlign: 'center', 
                padding: '40px', 
                maxWidth: '450px', 
                background: 'white', 
                borderRadius: '12px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
            }}>
                <div style={{ fontSize: '4rem', marginBottom: '20px' }}>
                    {getStatusIcon()}
                </div>

                <h2 style={{ color: '#00796B', marginBottom: '15px' }}>
                    {status === 'prompt' ? 'Confirmación Requerida' : message}
                </h2>
                
                {status !== 'prompt' && <p>{message}</p>}


                {/* Mostrar el botón solo si estamos listos para la verificación */}
                {status === 'prompt' && (
                    <button 
                        onClick={handleVerification}
                        style={{ 
                            padding: '12px 24px', 
                            fontSize: '18px', 
                            marginTop: '30px',
                            background: '#00796B',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontWeight: 'bold'
                        }}
                    >
                        VERIFICAR MI CUENTA
                    </button>
                )}

                {/* Link para volver a la página inicial o al Login */}
                {(status === 'success' || status === 'error') && (
                    <Link 
                        to="/" 
                        style={{ 
                            display: 'block', 
                            marginTop: '30px', 
                            color: '#00796B', 
                            fontWeight: 'bold',
                            textDecoration: 'none'
                        }}
                    >
                        Volver al inicio / Iniciar Sesión
                    </Link>
                )}
            </div>
        </div>
    );
}